export enum DocModeType {
  AllMarkup = 'edit',
  Final = 'final',
  Original = 'original',
}
